import { includes } from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize, deserializeArray } from 'santee-dcts';
import { Settings } from '../../core/settings';
import { Category, defaultReportSort, CategoryNaturalKey } from '../../documents';
import { DocumentsStorage } from '../../documents/documents-storage';
import { prepareFilterUrlParams } from '../../documents/prepare-filter-url-params';
import { ActivityReport, ActivityReportsReadModel } from '../../shared';
import { FilterFieldValue } from '../../covance-filter/covance-filter.models';
import { SponsorRouteData } from '../sponsor-route-data';
import { getSponsorActivityReportType } from './report-types/sponsor-activity-report-type-resolver';

export const RESTRICTED_SPONSOR_REPORTS_CATEGORIES: CategoryNaturalKey[] = ['lab-reports', 'result-alerts', 'equery'];

@Injectable()
export class SponsorActivityReportDocumentsStorage implements DocumentsStorage {

    constructor(
        private readonly http: HttpClient,
        private readonly settings: Settings,
        private readonly sponsorRouteData: SponsorRouteData
    ) { }

    public loadDocumentsByCategory(category: Category, filterParameters: FilterFieldValue[]): Observable<ActivityReport[]> {
        const filtersParams = prepareFilterUrlParams(filterParameters)
            .append('requestLimit', includes(RESTRICTED_SPONSOR_REPORTS_CATEGORIES, category.categoryId) ? this.settings.sqlRequestLimitForActivityReports.toString() : '0');

        return this.http.get(
                    `${this.settings.apiUrl}/sponsor/study/${this.sponsorRouteData.snapshot.selectedStudy.protocolId}/activity-reports/documents/${category.categoryId}`,
                    { params: filtersParams })
                        .pipe(
                            map(rawData => this.getActivityReportsForCategory(rawData, category))
                        );
    }

    private getActivityReportsForCategory(response: Object, category: Category) {
        const readModel = deserialize(response, ActivityReportsReadModel);

        const reportType = getSponsorActivityReportType(category.categoryId);
        let reports = deserializeArray(readModel.activityReports, reportType) as ActivityReport[];

        reports = reports.sort((a, b) => defaultReportSort(a, b));
        
        return reports;
    }
}
